<template>
  <div id="newsletter-type-create">
    <h2>Create Newsletter Type</h2>

    <newsletter-type-nav />

    <newsletter-type-digest-generator
      v-if="digest"
    />
    <newsletter-type-form />
  </div>
</template>

<script>
import NewsletterTypeDigestGenerator from '@/components/NewsletterTypeDigestGenerator'
import NewsletterTypeForm from '@/components/NewsletterTypeForm'
import NewsletterTypeNav from '@/components/NewsletterTypeNav'

export default {
  components: {
    'newsletter-type-form': NewsletterTypeForm,
    'newsletter-type-digest-generator': NewsletterTypeDigestGenerator,
    'newsletter-type-nav': NewsletterTypeNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeCreate.vue